<div>{{ label }}</div>
<div class="d-flex gap-2 mt-2">
    <button *ngFor="let amount of quickAddAmounts" (click)="onQuickAdd(amount)" class="btn btn-outline-dark">
        {{ amount }}
    </button>
</div>
